import { render, staticRenderFns } from "./UnsubscribeView.vue?vue&type=template&id=9542853e&scoped=true"
import script from "./UnsubscribeView.vue?vue&type=script&lang=js"
export * from "./UnsubscribeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9542853e",
  null
  
)

export default component.exports